import AbstractProductType from './AbstractProductType'
import { ProductTypeFormat } from './types'

export default class SelfIndoorOversized extends AbstractProductType {

  name = 'self_indoor_oversized'
  title = 'Self Indoor Oversized'

  oversized = true

  format = ProductTypeFormat.Indoor

}
